export default __webpack_public_path__ + "bc6aeadd5768f7fd0ba086bc1c176ff4.svg";